<!-- 待考试，重新预约页面-->
<!-- 自主报考预约时间，考场页面 -->
<template>
  <div class="content">
    <van-form @submit="gotoNext">
      <template v-if="theoryShow" >
        <h4>预约理论考试</h4>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点<span>*</span></div>
          <div class="Select" @click="ShowPlacePopup">
            <TestInput
              readonly
              :rtest="examaddress"
              :placeholder="'请选择考试地点'"
              :rules="[{ required: true }]"
            >
            </TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="PlaceShow"
          >
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="theoryPlaceConfirm"
              class="location-picker"
              cancel-button-text="选择考试地点"
            />
          </van-popup>
          <!-- 理论时间 -->
          <template >
            <div class="appoint-title">预约理论考试时间<span>*</span></div>
            <div class="Select" @click="ShowTimePopup">
              <TestInput
                readonly
                :rtest="examTime"
                :placeholder="'请选择理论考试时间'"
                :rules="[{ required: true }]"
              >
              </TestInput>
            </div>
            <van-popup
              position="bottom"
              round
              :style="{ height: '50%' }"
              v-model="TimeShow"
            >
              <div
                @click="theoryTimeConfirm"
                style="float: right; margin-top: 16px; margin-right: 20px"
                name="cross"
              >
                确定
              </div>
              <h4>选择考试时间</h4>
              <van-tree-select
                :items="theory.examTime"
                :active-id.sync="activeId"
                :main-active-index.sync="activeIndex"
                @click-item="selectTheoryTime"
                max="1"
              />
            </van-popup>
          </template>
        </div>
      </template>
      <!-- 实操地点 -->
      <template v-if="fieldShow" >
        <h4>预约实操考试</h4>
        <div class="subscribe_time">
          <div class="appoint-title">预约考试地点<span>*</span></div>
          <div class="Select" @click="operationPopup">
            <TestInput
              readonly
              :rtest="liveAddress"
              :placeholder="'请选择考试地点'"
              :rules="[{ required: true }]"
            >
            </TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="liveAddressShow"
          >
            <van-picker
              show-toolbar
              :columns="columnlives"
              @confirm="fieldPlaceConfirm"
              class="location-picker"
              cancel-button-text="选择考试地点"
            />
          </van-popup>
          <!-- 实操时间 -->
          <template >
            <div class="appoint-title">预约实操考试时间<span>*</span></div>
            <div class="Select" @click="filedShowTimePopup">
              <TestInput
                readonly
                :rtest="filedDataText"
                :placeholder="'请选择实操考试时间'"
                :rules="[{ required: true }]"
              >
              </TestInput>
            </div>
            <van-popup
              position="bottom"
              round
              :style="{ height: '50%' }"
              v-model="filedTimeShow"
            >
              <div
                @click="fieldTimeConfirm"
                style="float: right; margin-top: 16px; margin-right: 20px"
                name="cross"
              >
                确定
              </div>
              <h4>选择考试时间</h4>
              <van-tree-select
                :items="field.examTime"
                :active-id.sync="activeId"
                :main-active-index.sync="activeIndex"
                @click-item="selectFiledTime"
                max="1"
              />
            </van-popup>
          </template>
        </div>
        <!-- 带图标的确定弹窗 -->
        <van-dialog
          v-model="successDialog"
          confirm-button-color="#54B0FB"
          confirm-button-text="我知道了"
          @confirm="successHandler"
        >
          <div class="dialogHight">
            <div class="dialogBox">
              <img class="successImg" src="../../assets/succees.png" />
            </div>
            <div class="dialogDiV">重新预约成功，请准时参加考试！</div>
          </div>
        </van-dialog>
      </template>
      <div class="btn">
        <van-button block type="info" native-type="submit" :disabled="grayBtn"
          >确定</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import Select from "@/components/Select";
import TestInput from "@/components/choosec";
import { showaddres } from "../../api/apitotal.js";
import { Dialog, Notify, Toast } from "vant";
export default {
  components: {
    Select,
    TestInput,
  },
  data() {
    return {
      subjectList: [], //科目容器
      examaddress: "", //理论考试地点input
      liveAddress: "", //实操考试地点input
      occupationnr: "", //考试等级input
      selectedSubject: [], //复选框组勾选状态
      theoryState: false, //监听理论
      operationState: false, //监听实操
      activeId: "", //时间的右侧选中项的 id
      activeIndex: 0, //时间的左侧选中项的索引
      theoryData: {}, //理论时间数据
      filedData: {}, //实操时间数据
      disabled: false,
      active: 0, //步骤条索引
      TimeShow: false, //理论时间的弹出层开关
      filedTimeShow: false, //实操时间弹出层开关
      PlaceShow: false, //理论地点弹出层开关
      liveAddressShow: false, //实操地点弹出层开关
      columns: [], ////理论地点picker容器
      columnlives: [], //实操地点picker容器
      columnlive: [], //推送地址的空变量
      columnc: [], //推送地址的空变量
      infotestHint: false, //当前等级暂无考试
      signupDetails: {}, //接收数据容器
      occupationstatus: false, //科目弹出层开关
      occupation: [], //科目picker容器
      grayBtn: true, //下一步按钮  开关
      successDialog: false, //最后成功的弹窗
      theory: {
        appraisalId: "",
        subjectName: "",
        addressId: "",
        examTime: [], //理论时间数组
      },
      field: {
        appraisalId: "",
        subjectName: "",
        addressId: "",
        examTime: [], //理论时间数组
      },
      filedDataText: "", //实操考试时间input
      examTime: "", //理论考试时间input
      fieldShow:false,
      theoryShow:false
    };
  },
  computed: {
    examIds: function () {
      let arr = this.selectedSubject.map((item) => item.examId).join(",");
      console.log("217", arr);
      return arr;
    },
    isRejected: function () {
      return this.$route.query.status === "rejected";
    },
  },
  watch: {
    //监听实操时间input
    filedDataText: {
      handler() {
        if (this.filedDataText !== "") {
          this.grayBtn = false;
          return false;
        }
        console.log("触发了watch的filedDataText了");
      },
      deep: true,
    },
    //监听理论时间input
    examTime: {
      handler() {
        if (this.examTime !== "") {
          this.grayBtn = false;
          return false;
        }
        console.log("触发了watch的examTime");
      },
      deep: true,
    },
    // 监听实操时间
    filedData: function () {
      if (this.filedData.day && this.filedData.period) {
        this.filedDataText =
          this.filedData.day + " " + this.filedData.period;
      }
      console.log("触发了watch的filedData了");
    },
    // 监听理论时间
    theoryData: function () {
      if (this.theoryData.day && this.theoryData.period) {
        this.examTime = this.theoryData.day + " " + this.theoryData.period;
      }
      console.log("触发了watch的theoryData");
    },
    examIds: function (value) {
      console.log("89898989889", value);
      if (value) {
        this.fetchExamTime();
      }
      console.log("触发了watch的examIds了");
    },
  },

  async created() {
    if (this.$route.query.examOrderId != null) {
      console.log(this.$route.query)
      console.log(this.$route.query.examOrderId);
      await this.fetchSignupDetails(this.$route.query.examOrderId);
    } else {
      this.$http.get("ExamOrder/findDraft").then((res) => {
        if (res.data.success && res.data.data.examOrderId != null) {
          localStorage.setItem("examOrderId", res.data.data.examOrderId);
          this.fetchSignupDetails(res.data.data.examOrderId);
        }
      });
    }
    //暂无报考信息
    this.fetchExamLevel();
    //考试地址
    this.showaddress();
  },

  methods: {
    selectTheoryTime: function (value) {
      console.log(value);
      //选择的理论数据
      this.theoryData = value;
    },
    selectFiledTime: function (value) {
      //选择的实操数据
      this.filedData = value;
    },
    //请求考试等级
    fetchExamLevel: function () {
      const params = {
        ooccopationid: null,
      };
      this.$http.get("ExamAddress/FindListOccupation", params).then((res) => {
        if (res.status == 200) {
          if (res.data.length == 0) {
            this.$message({
              message: "暂无报考信息",
              type: "warning",
            });
          } else {
            this.occupation = res.data.data.levelDetails;
          }
        }
      });
    },
    //  请求赋值
    fetchSignupDetails: function (examOrderId) {
      var params = {
        examOrderId: examOrderId,
      };
      console.log(params);
      return new Promise((resolve) => {
        this.$http
          .post(`ExamOrder/findExamineInformation`, params)
          .then((res) => {
            if (res.data.success && res.data.data.examOrder != null) {
              this.theory.appraisalId = res.data.data.examOrder.appraisalBatchId
              this.field.appraisalId = res.data.data.examOrder.appraisalBatchId
              console.log(res);
              this.signupDetails = res.data.data.examOrder;
              //this.occupationnr = this.signupDetails.examRank; //等级input
              //this.theory.addressId = this.signupDetails.examAddressId; //理论考点id
             // this.field.addressId = this.signupDetails.liveAddressId; //实操考点ID
              resolve();
              console.log(this.signupDetails)
            }
            if (this.signupDetails.subject == "理论") {
              this.theoryShow = true
              console.log("走到理论？？？")
            }
            else if (this.signupDetails.subject == "实操") {
              this.fieldShow = true
              console.log("走到实操？？？")
            }else{
              console.log("走到理论+实操？？？")
              this.theoryShow = true
              this.fieldShow = true
            }
            console.log(this.signupDetails.subject)
          });
      });
    },
    // 请求时间的方法
    fetchExamTime: function (addressId, subjectName, appraisalId) {
      const params = {
        appraisalId: appraisalId,
        addressId: addressId,
        subject: subjectName,
      };
      this.$http.get("/registration/time", { params }).then((res) => {
        //TODO  理论
        if (res.data.success) {
          console.log(res);
          if (subjectName === "theory") {
            this.theory.examTime = res.data.data.timeList;
            this.theory.examTime.forEach((res) => {
              res.text = res.label;
              res.children.forEach((res1) => {
                res1.text = res1.period + ` 剩余${res1.remainNumber}人`;
                if (res1.remainNumber <= 0) {
                  res1.disabled = true;
                }
              });
            });
          }
          if (subjectName === "field") {
            console.log(subjectName);
            this.field.examTime = res.data.data.timeList;
            this.field.examTime.forEach((res) => {
              res.text = res.label;
              res.children.forEach((res1) => {
                res1.text = res1.period + ` 剩余${res1.remainNumber}人`;
                if (res1.remainNumber <= 0) {
                  res1.disabled = true;
                }
              });
            });
          }
        }
      });
    },
    //确定
    gotoNext: function () {
      Dialog.confirm({
        title: "提示",
        message: "确定要重新预约吗？",
        confirmButtonColor: "#54B0FB",
        confirmButtonText: "确定",
      }).then(() => {
        console.log("走到了确定提示框了", this.signupDetails);
        let subjectNameList = []
        this.selectedSubject.map(element => {
          subjectNameList.push(element.subjectName)
        })
        console.log(this.selectedSubject)
        const params1 = {
          subject:this.signupDetails.subject || subjectNameList.join('，'),
          theScheduleId: this.theoryData.id || "",
          opeScheduleId: this.filedData.id || "",
          id:
            this.$route.query.examOrderId ||
            null ||
            localStorage.getItem("examOrderId"),
          examRank: this.occupationnr,
          examAddress: this.examaddress || "",
          examAddressId: this.theory.addressId,
          liveAddressId: this.field.addressId,
          liveAddress: this.liveAddress || "",
        };
        console.log('打印科目看看',this.signupDetails.subject)
        console.log(this.selectedSubject)
        this.$http
          .post("ExamOrder/againMakeAppointment", params1)
          .then((ress) => {
            localStorage.removeItem("examOrderId");
            console.log(ress)
            if (ress.data.success) {
              console.log('这应该是显示成功大图标了',ress.data)
              //最后确定的按钮
              this.successDialog = true;
            } else {
              //错误提示
              Dialog.alert({
                confirmButtonText: "确认",
                confirmButtonColor: "#54B0FB",
                title: "提示",
                message: ress.data.msg,
              }).then(() => {
                // on close
              });
            }
          });
      });
    },

    //带成功图标的确定按钮
    successHandler() {
      console.log("走到最后的确定按钮了");
      this.$router.push({
        path: "/index",
      });
    },
    //请求考试等级的方法
    subjectshow() {
      var applanId = null;
      if (this.$route.query.applanId != null) {
        applanId = this.$route.query.applanId;
      }
      if (
        this.$route.query.ExamOrder &&
        this.$route.query.ExamOrder.appraisalBatchId != null
      ) {
        applanId = this.$route.query.ExamOrder.appraisalBatchId;
      }
      if (this.signupDetails.appraisalBatchId) {
        applanId = this.signupDetails.appraisalBatchId;
      }
      const params = {
        occupationName: this.occupationnr,
      };
      //查询批次  也就是等级
      this.$http.get(`ExamAddress/ShowBatch`, { params }).then((dat) => {
        if (dat.status == 200) {
          console.log(dat);
          const params1 = {
            appraisalBatchId: dat.data.data.occupationId,
          };
          //查询科目
          this.$http.post(`ExamAddress/ShowExam`, params1).then((dat) => {
            if (dat.status == 200) {
              let list = dat.data;
              if (list.length > 1 && list[0].subjectName === "实操") {
                this.subjectList = list.reverse();
              } else {
                this.subjectList = list;
              }

              console.log(this.subjectList);
              if (this.subjectList.length > 0) {
                this.infotestHint = false;
                this.grayBtn = false;
              } else {
                this.infotestHint = true;
                this.grayBtn = true;
              }
              //解决第一次赋值   第二次还赋值的状况
              // if(this.craftStatus){
              //  草稿科目赋值
              if (this.selectedSubject && this.craftStatus) {
                console.log("走到科目草稿状态了", this.subjectList);
                let selectSubject = this.signupDetails.subject.split("，");
                //  去除重复的科目
                selectSubject.forEach((ele) => {
                  console.log(
                    "subject:" +
                      ele +
                      " of index of list:" +
                      this.subjectList.indexOf(ele)
                  );
                  let findResult1 = this.subjectList.filter(
                    (ele1) => ele1.subjectName === ele
                  );
                  let findResult2 = this.selectedSubject.filter(
                    (ele1) => ele1.subjectName === ele
                  );
                  if (findResult1.length > 0 && findResult2.length == 0) {
                    this.selectedSubject.push(findResult1[0]);
                  }
                });
                console.log(this.selectedSubject);
              }
            }
          });
        }
      });
      // 考试科目
    },
    // 考试地址
    showaddress() {
      this.$http.get("ExamAddress/ShowAll").then((res) => {
        if (res.data.success && res.status == 200) {
          this.columnc = res.data.data.list;
          this.columnlive = res.data.data.list;
          this.columnlive.forEach((element) => {
            this.columnlives.push(element.examAddressName);
          });
          this.columnc.forEach((element) => {
            this.columns.push(element.examAddressName);
          });
        }
      });
    },
    //预约考试等级
    Showoccupation(isRejectedFlag) {
      if (isRejectedFlag) return false;
      this.occupationstatus = true;
    },
    //理论地点popup确定按钮
    ShowPlacePopup() {
         this.PlaceShow = true;
    },
    //实操地点popup
    operationPopup() {
        this.liveAddressShow = true;
    },
    //理论时间确定按钮
    ShowTimePopup() {
        this.TimeShow = true;
    },
    //实操时间确定按钮
    filedShowTimePopup() {
        this.filedTimeShow = true;
    },
    //考试等级picker确定按钮
    onOccupiton(value, index) {
      this.occupationnr = value;
      this.occupationstatus = false;
      console.log(value)
    },
    //理论地点确定按钮
    theoryPlaceConfirm(value, index) {
      this.examaddress = value;
      this.theory.addressId = this.columnc[index].id;
      this.theory.subjectName = "theory";
     // this.theory.addressId = this.columnc[index].id;
      this.fetchExamTime(
        this.theory.addressId,
        this.theory.subjectName,
        this.theory.appraisalId
      );
      this.PlaceShow = false;
    },
    //理论时间确定按钮
    theoryTimeConfirm(value, index) {
      this.TimeShow = false;
    },
    //实操地点确定按钮
    fieldPlaceConfirm(value, index) {
      this.liveAddress = value;
      this.field.addressId = this.columnc[index].id;
      this.field.subjectName = "field"
      this.fetchExamTime(
        this.field.addressId,
        this.field.subjectName,
        this.field.appraisalId
      );
      this.liveAddressShow = false;
    },
    //实操时间确定按钮
    fieldTimeConfirm(picker, value, index) {
      this.filedTimeShow = false;
    },
  },
};
</script>
 
<style scoped lang="less">
.checkmargin {
  padding: 18px;
  background: @whitee;
}
.checkmargin:last-child {
  padding-bottom: @padingboxmax;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: @whitee;
}
.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
#top {
  width: 100%;
  height: 70px;
  line-height: 70px;
  vertical-align: middle;
  background-color: rgba(245, 245, 245);
}
.subscribe {
  background-color: #fff;
  width: 100%;
  height: 250px;
}
.subscribe_time {
  padding: 30px;
  background-color: #fff;
}
::v-deep .van-radio {
  margin-bottom: 35px;
}
.Select {
  width: 100%;
  height: @minboxgao;
  margin: @padingboxmax 0;
  line-height: @minboxgao;
}
.Selects {
  width: 690px;
  height: @minboxgao;
  margin: @padingboxmax 0;
  line-height: @minboxgao;
}

.choose1_text {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 12px 0;
}
.choose1_textt {
  display: inline-block;
  width: 175px;
}
.choose1_check {
  width: 25px;
  height: 25px;
}
h4 {
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @backgroundcolor;
}
.appoint-title {
  height: @textgao;
  line-height: @textgao;
  margin-top: 18px;
  span {
    color: red;
  }
}
.btnbox {
  // position: absolute;
  padding: 38px;
  margin: 0 auto;
  width: 93%;
  box-sizing: border-box;
  background: @whitee;
  // bottom: 0;
}
.btnbox_next {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 20px 30px;
}
#top {
  text-align: center;
  height: 176px;
  box-sizing: border-box;
  padding-top: 125px;
  background-color: @backgroundcolor;
  padding-bottom: 69px;
}
.location-picker .van-picker__toolbar {
  padding: 4px;
}

.location-picker .van-picker__cancel {
  font-weight: bold;
  font-size: 16px;
  color: white;
}
.van-checkbox-group {
  flex-direction: column;
}
.ceshi {
  border: 1px solid #dcdcdc;
  width: 690px;
  height: 90px;
  margin: 24px 29px;
  border-radius: 10px;
}
.btn {
  // width: 100%;
  position: fixed;
  bottom: 20px;
  margin-left: 30px;
  width: 690px;
  height: 90px;
  background: #54b0fb;
  border-radius: 8px;
}
.warning-msg {
  color: red;
}
.dialogHight {
  height: 300px;
  .dialogBox {
    margin-top: 30px;
    padding: 80px auto;
    display: flex;
    justify-content: center;
    .successImg {
      height: 148px;
      width: 148px;
    }
  }
  .dialogDiV {
    margin-top: 60px;
    display: flex;
    justify-content: center;
  }
}
</style>